import { DATE_INPUT_TIME_FORMAT } from 'constants/reporting';
import dayjs from 'dayjs';
import { CallStatus, ICallSentiment, Sentiment } from 'interfaces/Reporting';
import { RecentRange } from 'utils/dateRangeHistory';

const getValidSentiments = (sentiments: ICallSentiment | null) => {
  if (!sentiments) return { neg: 0, neu: 0, pos: 0 };

  const newSentiments = { ...sentiments };
  delete newSentiments.compound;
  return newSentiments;
};

const getHighestSentiment = (sentiments: ICallSentiment | null) => {
  return Object.entries(getValidSentiments(sentiments)).reduce(
    (max, [key, value]) => (value > max[1] ? [key, value] : max),
    ['', -Infinity]
  ) as [Sentiment, number];
};

const sentimentLabels = {
  [Sentiment.POSITIVE]: 'Positive',
  [Sentiment.NEUTRAL]: 'Neutral',
  [Sentiment.NEGATIVE]: 'Negative',
};

const callStatusLabels = {
  [CallStatus.RESOLVED]: 'Resolved',
  [CallStatus.TRANSFERRED]: 'Transferred',
  [CallStatus.MESSAGE_TAKEN]: 'Message taken',
  [CallStatus.UNRESOLVED]: 'Unresolved',
  [CallStatus.INCOMPLETE]: 'Incomplete',
  [CallStatus.UNKNOWN]: 'Unknown',
};

const getInputRangeLabel = (range: Partial<RecentRange> & { disableTime?: boolean }) => {
  const format = range.disableTime ? 'YYYY-MM-DD' : DATE_INPUT_TIME_FORMAT;
  return `${dayjs(range.from).format(format)} - ${dayjs(range.to).format(format)}`;
};

export {
  getValidSentiments,
  getHighestSentiment,
  sentimentLabels,
  callStatusLabels,
  getInputRangeLabel,
};
